module.exports = __webpack_public_path__ + "static/media/paper-dark_thumbnail.f92e9278.png";